import * as Api from '../../../../../../extViewmodels';
import { ContactTimelineCard } from './card';
import { ContactTimelineDate } from './date';

interface IProps {
	item: Api.TimelineEventViewModel<Api.ITimelineEvent> | Date;
	contactEmailAddresses: Api.EmailAddress[];
	contactName: string;
	expandAllTimeline?: boolean;
	onDeleteRichContent: (richContent: Api.RichContentViewModel) => Promise<Api.IRichContent>;
	onMoreMenuOptionClicked?: (
		richContent: Api.RichContentViewModel,
		option: 'edit' | 'delete',
		e: React.MouseEvent<HTMLElement>
	) => void;
	onTimelineDataUpdated: () => void;
}

export const ContactTimelineItem = ({
	item,
	contactEmailAddresses,
	contactName,
	expandAllTimeline,
	onDeleteRichContent,
	onMoreMenuOptionClicked,
	onTimelineDataUpdated,
}: IProps) => {
	if (item instanceof Date) {
		return <ContactTimelineDate date={item} />;
	}

	return (
		<ContactTimelineCard
			item={item}
			contactEmailAddresses={contactEmailAddresses}
			contactName={contactName}
			expandAllTimeline={expandAllTimeline}
			onDeleteRichContent={onDeleteRichContent}
			onMoreMenuOptionClicked={onMoreMenuOptionClicked}
			onTimelineDataUpdated={onTimelineDataUpdated}
		/>
	);
};
